const $inject = [];
const lbaFileDownloader = function () {
  return {
    restrict: 'A',
    scope: {
      settings: '<',
    },
    bindToController: true,
    controller: 'lbaFileDownloaderCtrl',
    controllerAs: 'vm',
    template: require('./lbaFileDownloader.html')
  }
};

lbaFileDownloader.$inject = $inject;

export default lbaFileDownloader;



// WEBPACK FOOTER //
// ./src/components/lbaFileDownloader/lbaFileDownloaderDir.js